import { render, staticRenderFns } from "./ConformityCard.vue?vue&type=template&id=207a8230&scoped=true&"
import script from "./ConformityCard.vue?vue&type=script&lang=js&"
export * from "./ConformityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207a8230",
  null
  
)

export default component.exports